import { FC } from 'react';
import { isBefore } from 'date-fns';
import { getMessageAndColorForExpirationTime } from '../../time/date-formatter';
import { useTime } from '../../providers';
import { LabelTypography } from '../LabelTypography';

export const PastDateLabel: FC<{
  date: Date;
}> = ({ date }) => {
  const now = useTime();

  const [text] = getMessageAndColorForExpirationTime({
    date,
    now,
  });
  // Красная когда в будущем
  const type = isBefore(now, date) ? 'warning' : 'success';
  return <LabelTypography text={text} type={type} />;
};
